import type { SVGProps } from 'react'

export const UpTwo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320' {...props}>
    <path d='M0,96L48,85.3C96,75,192,53,288,64C384,75,480,117,576,122.7C672,128,768,96,864,74.7C960,53,1056,43,1152,74.7C1248,107,1344,181,1392,218.7L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'></path>
  </svg>
)

UpTwo.toString = () => 'up2'
